export function toFixedFilter(amount: number, decimals: number): string {
  return amount.toFixed(decimals);
}
